import React from "react";
import { sanitizePhrase } from "../../utils/phrase-formatting";

interface FormattedTextProps {
  text: string;
  className?: string;
  style?: React.CSSProperties;
}

const FormattedText: React.FC<FormattedTextProps> = ({ text, className, style }) => {
  return (
    <span
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizePhrase(text) }}
    />
  );
};

export default FormattedText;
